webpackJsonp([57],{

/***/ 1298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);






var metas = {
  "category": {
    "en": "Form",
    "zh-CN": "表单"
  },
  "icon": "&#xe62b;",
  "tags": {
    "en": ["form", "calendar"],
    "zh-CN": ["日历", "表单"]
  },
  "props": {
    "value": {
      "type": "String, Array",
      "default": "",
      "en": "calendar value, use `v-modle` for binding. String (including empty) means single seleciton; array (including empty array) means multiple selection.",
      "zh-CN": "当前选中日期，使用`v-model`绑定。值为字符串(包括空字符串)时表示单选日期，为数组(包括空数组)时表示多选。"
    },
    "render-month": {
      "type": "Array",
      "default": "",
      "en": "specify which date to render, for example [2018, 8]",
      "zh-CN": "指定渲染日期，如 [2018, 8]"
    },
    "start-date": {
      "type": "String",
      "default": "",
      "en": "start date with format `YYYY-MM-dd`",
      "zh-CN": "起始日期，格式为 `YYYY-MM-dd`"
    },
    "end-date": {
      "type": "String",
      "default": "",
      "en": "end date with format `YYYY-MM-dd`",
      "zh-CN": "结束日期，格式为`YYYY-MM-dd`"
    },
    "show-last-month": {
      "type": "Boolean",
      "default": true,
      "en": "if show last month's days",
      "zh-CN": "是否显示上个月的日期"
    },
    "show-next-month": {
      "type": "Boolean",
      "default": true,
      "en": "if show next month's days",
      "zh-CN": "是否显示下个月的日期"
    },
    "highlight-weekend": {
      "type": "Boolean",
      "default": false,
      "en": "if highlight weekend days",
      "zh-CN": "是否高亮周末"
    },
    "return-six-rows": {
      "type": "Boolean",
      "default": true,
      "en": "if always show six rows",
      "zh-CN": "是否总是渲染6行日期"
    },
    "hide-header": {
      "type": "Boolean",
      "default": false,
      "en": "if hiding header",
      "zh-CN": "是否隐藏日历头部"
    },
    "hide-week-list": {
      "type": "Boolean",
      "default": false,
      "en": "if hiding week list",
      "zh-CN": "是否隐藏星期列表"
    },
    "replace-text-list": {
      "type": "Object",
      "default": "",
      "en": "replace list, for example, {'TODAY':'今'}",
      "zh-CN": "替换列表，可以将默认的日期换成文字，比如今天的日期替换成今，{'TODAY':'今'}"
    },
    "weeks-list": {
      "type": "Array",
      "default": "['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']",
      "en": "week list, starting from `Sunday`",
      "zh-CN": "星期列表，从周日开始"
    },
    "render-function": {
      "type": "Function",
      "default": "",
      "en": "render function to add extra contents, params `(line, row, dateData)`",
      "zh-CN": "用于为特定日期添加额外的html内容，参数为(行index,列index,日期详细属性)"
    },
    "render-on-value-change": {
      "type": "Boolean",
      "default": true,
      "en": "if re-render calendar if value changes, should set to false when showing multi months",
      "zh-CN": "当日期变化时是否重新渲染日历，如果是渲染了多个日历的话需要设为false"
    },
    "disable-past": {
      "type": "Boolean",
      "default": false,
      "en": "if disable the past days, can work with start-date",
      "zh-CN": "禁止选择过去的日期，该选项可以与 start-date 同时使用"
    },
    "disable-future": {
      "type": "Boolean",
      "default": false,
      "en": "if disable future days, can work with end-date",
      "zh-CN": "禁止选择未来的日期，该选项可以 end-date 同时使用"
    },
    "marks": {
      "version": "v2.6.0",
      "type": "Array",
      "en": "(beta) style marks for specified date list",
      "zh-CN": "(beta) 自定义日期标记"
    },
    "disable-weekend": {
      "version": "v2.7.0",
      "type": "Boolean",
      "default": false,
      "en": "whether disable weekends",
      "zh-CN": "是否禁用周六日"
    },
    "disable-date-function": {
      "version": "v2.7.0",
      "type": "Function",
      "params": "`(date)`",
      "en": "check if a date should be disabled",
      "zh-CN": "自定义标记特定日期是否应该禁用，返回 true 表示禁用，false 表示不禁用，不返回表示和原有逻辑一致(这样不影响和 disable-weekend 等禁用属性同时使用)"
    }
  },
  "slots": {
    "each-day": {
      "version": "v2.3.5",
      "en": "you can custom how to display each day",
      "zh-CN": "用以自定义每一天的显示渲染，推荐使用该 slot 来替代 render-function"
    }
  },
  "events": {
    "on-change": {
      "en": "emits when value is changed",
      "zh-CN": "值变化时触发"
    },
    "on-view-change": {
      "version": "v2.5.12",
      "params": "(data, index)",
      "en": "fires when render month is changed",
      "zh-CN": "渲染月份变化时触发。初始化时会触发一次，如果不希望处理初始化时的触发，可以检查第二个参数是否为 0"
    },
    "on-select-single-date": {
      "version": "2.7.6",
      "params": "(currentValue)",
      "en": "fires when date is selected in radio mode",
      "zh-CN": "单选模式下选中日期时触发"
    }
  },
  "methods": {
    "getDates": {
      "version": "v2.5.11",
      "en": "get current date list",
      "zh-CN": "获取当前日期列表"
    },
    "switchViewToToday": {
      "version": "v2.5.12",
      "en": "render current month",
      "zh-CN": "渲染当天所在月份"
    },
    "switchViewToMonth": {
      "version": "v2.5.12",
      "params": "(year, month)",
      "en": "render specified year and month",
      "zh-CN": "渲染特定年月日期"
    },
    "switchViewToCurrentValue": {
      "version": "v2.5.12",
      "en": "render with current value's month",
      "zh-CN": "渲染当前值所在月份"
    }
  },
  "changes": {
    "v2.7.6": {
      "en": ["[feature] add event:on-select-single-date"],
      "zh-CN": ["[feature] 添加事件 on-select-single-date"]
    },
    "v2.7.3": {
      "en": ["[fix] disable-date-function result conflicts with disable-weekend #2189"],
      "zh-CN": ["[fix] 修复 disable-date-function 取值与禁用周末逻辑冲突 #2189"]
    },
    "v2.7.2": {
      "en": ["[fix] fix reset-value issue in multiple mode #2160", "[fix] fix props missing in calendar #2105", "[fix] fix disabled weekends still selectable #2178"],
      "zh-CN": ["[fix] 修复多选情况下重置值时没有正确渲染的问题 #2160", "[fix] 修复部分属性没有继承 inline-calendar 的问题 #2105", "[fix] 修复禁用周末日期仍能点击的问题 #2178"]
    },
    "v2.7.0": {
      "en": ["[enhance] call render function on created hook instead of mounted(ssr)", "[feature] add prop:disable-weekend #2105", "[feature] add prop:disable-date-function #2105", "[fix] remove useless re-render function #2066"],
      "zh-CN": ["[enhance] 在 created hook 执行渲染而不是 mounted(ssr)", "[feature] 添加属性 prop:disable-weekend 来禁用周末 #2105", "[feature] 添加属性 prop:disable-date-function 自定义标记禁用日期 #2105", "[fix] 移除重复的多次重复渲染 #2066"]
    },
    "v2.6.0": {
      "en": ["[feature] (beta) Support prop:marks to style specified date item", "[fix] fix i18n for days"],
      "zh-CN": ["[feature] (beta) 支持属性 marks 用以自定义特定日期显示样式", "[fix] 修复星期文字 i18n"]
    },
    "v2.5.12": {
      "en": ["[feature] add method:switchViewToToday switchViewToMonth", "[feature] support event:on-view-change"],
      "zh-CN": ["[feature] 支持 switchViewToToday, switchViewToMonth 等手动渲染方法", "[feature] 支持事件 on-view-change，方便切换月份时请求数据"]
    },
    "v2.5.11": {
      "en": ["[feature] support method:getDates", "[feature] support less variable @calendar-bg-color"],
      "zh-CN": ["[feature] 支持方法 getDates 用于需要获取渲染日期列表的场合", "[feature] 支持 less 变量 @calendar-bg-color"]
    },
    "v2.5.9": {
      "en": ["[fix] donot set value to empty string when clicking on current selected item #1862"],
      "zh-CN": ["[fix] 点击当前日期项时不把值置为空 #1862"]
    },
    "v2.5.8": {
      "en": ["[fix] fix on-change event fires twice #1847"],
      "zh-CN": ["[fix] 修复 on-change 事件触发两次问题 #1847"]
    },
    "v2.5.5": {
      "en": ["[feature] support multi select #1446 #1467"],
      "zh-CN": ["[feature] 支持多选 #1446 #1467"]
    },
    "v2.4.0": {
      "en": ["[enhance] re-render when render-month is changed"],
      "zh-CN": ["[enhance] 当 render-month 变化时重新渲染日历"]
    },
    "v2.3.8": {
      "en": ["[enhance] prevent from clicking invisiable date #1564"],
      "zh-CN": ["[enhance] 不可见日期不可点击 #1564"]
    },
    "v2.3.6": {
      "en": ["[change] render-function params day => date #1361"],
      "zh-CN": ["[change] render-function 参数 day => date（在 3.0 版本前不会影响目前使用）#1361"]
    },
    "v2.3.5": {
      "en": ["[feature] Support slot:each-day"],
      "zh-CN": ["[feature] 支持自定义每一天的 html 渲染 slot:each-day"]
    },
    "v2.3.1": {
      "en": ["[fix] Fix render-function-generated-content visibility issue #1409"],
      "zh-CN": ["[fix] 修复 render-function 生成的内容错误显示问题 #1409"]
    },
    "v2.2.2": {
      "en": ["[enhance] when replace text of date is empty string, span of date will not show"],
      "zh-CN": ["[enhance] 当日期的替代文字为空字符串时，包含日期的 `span` 元素将不显示"]
    },
    "v2.2.1-rc.2": {
      "en": ["[enhance] Now next month's day can be clicked and will automatically switch to next month's view #1192", "[fix] fix start-date and end-date not reactive #1219"],
      "zh-CN": ["[enhance] 可以点击下个月日期并自动切换到下个月 #1192", "[fix] 修复 start-date 和 end-date 变化后不重新渲染的问题 #1219"]
    },
    "v2.1.1-rc.10": {
      "en": ["[feature] Add more less variables. #896"],
      "zh-CN": ["[feature] 支持多个 less 变量. #896"]
    },
    "v2.1.1-rc.5": {
      "en": ["[fix] fix render-function not reactive"],
      "zh-CN": ["[fix] 修复 render-function 变化不重新渲染的问题"]
    }
  }
};
var demos = [];

var componentList = [];
if (Array.isArray(metas.items)) {
  try {
    metas.items.forEach(function (item, index) {
      var meta = {
        name: item,
        meta: metas[item]
      };
      if (meta.meta.props === null) {
        delete meta.meta.props;
      }
      if (index === metas.items.length - 1) {
        if (meta.meta) {
          meta.meta.variables = metas.variables;
        }
      }
      componentList.push(meta);
    });
  } catch (e) {
    console.log(e);
  }
} else {
  componentList.push({
    meta: metas
  });
}
var gitMetas = __webpack_require__(2512);
var demoCode = decodeURIComponent("%3Cpre%20class%3D%22hljs%22%3E%3Ccode%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Etemplate%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ediv%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Einline-calendar%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-attr%22%3Eref%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22calendar%22%3C%2Fspan%3E%0A%20%20%40%3Cspan%20class%3D%22hljs-attr%22%3Eon-change%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22onChange%22%3C%2Fspan%3E%0A%20%20%40%3Cspan%20class%3D%22hljs-attr%22%3Eon-view-change%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22onViewChange%22%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-attr%22%3Eclass%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22inline-calendar-demo%22%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Ashow.sync%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22show%22%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-attr%22%3Ev-model%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22value%22%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-attr%22%3Estart-date%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%222016-04-01%22%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Aend-date%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22endDate%22%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Arange%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22range%22%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Ashow-last-month%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22showLastMonth%22%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Ashow-next-month%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22showNextMonth%22%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Ahighlight-weekend%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22highlightWeekend%22%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Areturn-six-rows%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22return6Rows%22%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Ahide-header%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22hideHeader%22%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Ahide-week-list%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22hideWeekList%22%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Areplace-text-list%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22replaceTextList%22%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Aweeks-list%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22weeksList%22%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Arender-function%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22buildSlotFn%22%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Adisable-past%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22disablePast%22%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Adisable-future%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22disableFuture%22%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Adisable-weekend%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22disableWeekend%22%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Adisable-date-function%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22disableDateFunction%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Einline-calendar%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%0A%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Egroup%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Current%20value')%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Avalue%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22value%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Start%20date')%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Evalue%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%222016-04-01%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('End%20date')%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Evalue%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%222018-05-30%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Egroup%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%0A%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ediv%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Estyle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22margin%3A%2015px%3B%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ex-button%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Etype%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22primary%22%3C%2Fspan%3E%20%40%3Cspan%20class%3D%22hljs-attr%22%3Eclick.native%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24refs.calendar.switchViewToToday()%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3EswitchViewToToday%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ex-button%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ex-button%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Etype%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22primary%22%3C%2Fspan%3E%20%40%3Cspan%20class%3D%22hljs-attr%22%3Eclick.native%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24refs.calendar.switchViewToMonth(2017%2C%2012)%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3EswitchViewToMonth(2017%2C%2012)%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ex-button%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ex-button%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Etype%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22primary%22%3C%2Fspan%3E%20%40%3Cspan%20class%3D%22hljs-attr%22%3Eclick.native%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24refs.calendar.switchViewToMonth(2018%2C%2010)%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3EswitchViewToMonth(2018%2C%2010)%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ex-button%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ex-button%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Etype%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22primary%22%3C%2Fspan%3E%20%40%3Cspan%20class%3D%22hljs-attr%22%3Eclick.native%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24refs.calendar.switchViewToCurrentValue()%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3EswitchViewToCurrentValue%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ex-button%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ediv%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%0A%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Egroup%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Control%20days')%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Estyle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22margin-top%3A%2030px%3B%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ex-switch%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Ev-model%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22disablePast%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Disable%20past')%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ex-switch%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ex-switch%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Ev-model%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22disableFuture%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Disable%20future')%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ex-switch%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ex-switch%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Ev-model%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22disableWeekend%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Disable%20weekend')%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ex-switch%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ex-switch%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Ev-model%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22showLastMonth%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Show%20last%20month')%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ex-switch%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ex-switch%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Ev-model%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22showNextMonth%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Show%20next%20month')%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ex-switch%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ex-switch%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Ev-model%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22return6Rows%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Ainline-desc%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('If%20not%2C%20the%20height%20of%20calendar%20would%20change')%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Always%20show%206%20rows')%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ex-switch%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ex-switch%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Ev-model%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22highlightWeekend%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Highlight%20weekend')%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ex-switch%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Current%20value')%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Avalue%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22value%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Egroup%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Egroup%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Control%20navs')%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ex-switch%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Ev-model%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22hideHeader%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Hide%20header')%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ex-switch%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ex-switch%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Ev-model%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22hideWeekList%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Hide%20week%20list')%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ex-switch%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ex-switch%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Ev-model%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22changeWeeksList%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Change%20week%20list')%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ex-switch%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Egroup%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Egroup%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Replace%20text')%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ex-switch%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Ev-model%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22replace%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Replace%20date%20text')%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ex-switch%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Egroup%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ebr%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ediv%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Estyle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22margin%3A%2015px%3B%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ex-button%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Etype%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22primary%22%3C%2Fspan%3E%20%40%3Cspan%20class%3D%22hljs-attr%22%3Eclick.native%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22value%3D'2020-11-11'%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%20%7B%7B%20%24t('Set%20time%20to')%20%7D%7D%202020-11-11%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ex-button%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ex-button%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Etype%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22primary%22%3C%2Fspan%3E%20%40%3Cspan%20class%3D%22hljs-attr%22%3Eclick.native%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22value%3D'2020-11-22'%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%20%7B%7B%20%24t('Set%20time%20to')%20%7D%7D%202020-11-22%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ex-button%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ex-button%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Etype%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22primary%22%3C%2Fspan%3E%20%40%3Cspan%20class%3D%22hljs-attr%22%3Eclick.native%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22value%3D'2016-08-09'%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%20%7B%7B%20%24t('Set%20time%20to')%20%7D%7D%202016-08-09%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ex-button%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ex-button%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Etype%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22primary%22%3C%2Fspan%3E%20%40%3Cspan%20class%3D%22hljs-attr%22%3Eclick.native%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22value%3D'TODAY'%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%20%7B%7B%20%24t('Set%20time%20to')%20%7D%7D%20today%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ex-button%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ex-button%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Etype%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22primary%22%3C%2Fspan%3E%20%40%3Cspan%20class%3D%22hljs-attr%22%3Eclick.native%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22value%3D'2016-06-05'%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%20%7B%7B%20%24t('Set%20time%20to')%20%7D%7D%202016-06-05%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ex-button%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ediv%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ebr%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Egroup%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Custom%20every%20day%20cell')%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ex-switch%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Ev-model%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22useCustomFn%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Ainline-desc%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Add%20red%20dot%20for%20dates%20with%20number%208')%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Add%20custom%20contents%20in%20day%20cell')%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ex-switch%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Egroup%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%0A%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ebr%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%0A%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Edivider%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%20%7B%7B%20%24t('We%20can%20render%20a%20list%20of%20calendars%20order%20by%20month')%20%7D%7D%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Edivider%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Egroup%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Current%20value')%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Avalue%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22listValue%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Egroup%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ebr%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ediv%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Etemplate%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%0A%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ei18n%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0AStart%20date%3A%0A%20%20zh-CN%3A%20%E5%BC%80%E5%A7%8B%E6%97%A5%E6%9C%9F%0AEnd%20date%3A%0A%20%20zh-CN%3A%20%E7%BB%93%E6%9D%9F%E6%97%A5%E6%9C%9F%0AControl%20days%3A%0A%20%20zh-CN%3A%20%E6%8E%A7%E5%88%B6%E6%97%A5%E6%9C%9F%0ADisable%20past%3A%0A%20%20zh-CN%3A%20%E7%A6%81%E6%AD%A2%E9%80%89%E6%8B%A9%E6%9C%AA%E6%9D%A5%E7%9A%84%E6%97%A5%E6%9C%9F%0ADisable%20future%3A%0A%20%20zh-CN%3A%20%E7%A6%81%E6%AD%A2%E9%80%89%E6%8B%A9%E8%BF%87%E5%8E%BB%E7%9A%84%E6%97%A5%E6%9C%9F%0ADisable%20weekend%3A%0A%20%20zh-CN%3A%20%E7%A6%81%E6%AD%A2%E9%80%89%E6%8B%A9%E5%91%A8%E6%9C%AB%E6%97%A5%E6%9C%9F%0AShow%20last%20month%3A%0A%20%20zh-CN%3A%20%E6%98%BE%E7%A4%BA%E4%B8%8A%E4%B8%AA%E6%9C%88%0AShow%20next%20month%3A%0A%20%20zh-CN%3A%20%E6%98%BE%E7%A4%BA%E4%B8%8B%E4%B8%AA%E6%9C%88%0AAlways%20show%206%20rows%3A%0A%20%20zh-CN%3A%20%E5%9B%BA%E5%AE%9A%E6%98%BE%E7%A4%BA6%E8%A1%8C%0AIf%20not%2C%20the%20height%20of%20calendar%20would%20change%3A%0A%20%20zh-CN%3A%20%E5%90%A6%E5%88%99%EF%BC%8C%E6%97%A5%E5%8E%86%E7%9A%84%E9%AB%98%E5%BA%A6%E4%BC%9A%E5%8F%91%E7%94%9F%E6%94%B9%E5%8F%98%0AHighlight%20weekend%3A%0A%20%20zh-CN%3A%20%E9%AB%98%E4%BA%AE%E5%91%A8%E6%9C%AB%0AControl%20navs%3A%0A%20%20zh-CN%3A%20%E6%8E%A7%E5%88%B6%E5%AF%BC%E8%88%AA%E9%83%A8%E5%88%86%0AHide%20header%3A%0A%20%20zh-CN%3A%20%E9%9A%90%E8%97%8F%E6%97%A5%E5%8E%86%E5%A4%B4%E9%83%A8%0AHide%20week%20list%3A%0A%20%20zh-CN%3A%20%E9%9A%90%E8%97%8F%E6%98%9F%E6%9C%9F%E5%88%97%E8%A1%A8%0AChange%20week%20list%3A%0A%20%20zh-CN%3A%20%E5%88%87%E6%8D%A2%E6%98%9F%E6%9C%9F%E5%88%97%E8%A1%A8%0AReplace%20text%3A%0A%20%20zh-CN%3A%20%E6%9B%B4%E6%8D%A2%E6%96%87%E6%9C%AC%0AReplace%20date%20text%3A%0A%20%20zh-CN%3A%20%E6%9B%BF%E6%8D%A2%E6%97%A5%E6%9C%9F%E6%96%87%E6%9C%AC%0ASet%20time%20to%3A%0A%20%20zh-CN%3A%20%E8%AE%BE%E7%BD%AE%E4%B8%BA%0ACustom%20every%20day%20cell%3A%0A%20%20zh-CN%3A%20%E8%87%AA%E5%AE%9A%E4%B9%89%E6%97%A5%E6%9C%9F%E5%8D%95%E5%85%83%E6%A0%BC%0AAdd%20custom%20contents%20in%20day%20cell%3A%0A%20%20zh-CN%3A%20%E5%9C%A8%E6%97%A5%E6%9C%9F%E5%8D%95%E5%85%83%E6%A0%BC%E4%B8%AD%E6%B7%BB%E5%8A%A0%E8%87%AA%E5%AE%9A%E4%B9%89%E5%86%85%E5%AE%B9%0AAdd%20red%20dot%20for%20dates%20with%20number%208%3A%0A%20%20zh-CN%3A%20%E4%B8%BA%E5%B8%A6%E6%9C%89%E6%95%B0%E5%AD%978%E7%9A%84%E6%97%A5%E6%9C%9F%E6%B7%BB%E5%8A%A0%E7%BA%A2%E7%82%B9%0AWe%20can%20render%20a%20list%20of%20calendars%20order%20by%20month%3A%0A%20%20zh-CN%3A%20%E6%8C%89%E6%9C%88%E4%BB%BD%E9%A1%BA%E5%BA%8F%E6%B8%B2%E6%9F%93%E4%B8%80%E7%B3%BB%E5%88%97%E6%97%A5%E5%8E%86%0A%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ei18n%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%0A%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Escript%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22javascript%22%3E%0A%3Cspan%20class%3D%22hljs-keyword%22%3Eimport%3C%2Fspan%3E%20%7B%20InlineCalendar%2C%20Group%2C%20XSwitch%2C%20Radio%2C%20XButton%2C%20Cell%2C%20Divider%20%7D%20%3Cspan%20class%3D%22hljs-keyword%22%3Efrom%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-string%22%3E'vux'%3C%2Fspan%3E%0A%3Cspan%20class%3D%22hljs-keyword%22%3Eimport%3C%2Fspan%3E%20dayjs%20%3Cspan%20class%3D%22hljs-keyword%22%3Efrom%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-string%22%3E'dayjs'%3C%2Fspan%3E%0A%0A%3Cspan%20class%3D%22hljs-keyword%22%3Eexport%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-keyword%22%3Edefault%3C%2Fspan%3E%20%7B%0A%20%20%3Cspan%20class%3D%22hljs-attr%22%3Emethods%3C%2Fspan%3E%3A%20%7B%0A%20%20%20%20onChange%20(val)%20%7B%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-built_in%22%3Econsole%3C%2Fspan%3E.log(%3Cspan%20class%3D%22hljs-string%22%3E'on-change'%3C%2Fspan%3E%2C%20val)%0A%20%20%20%20%7D%2C%0A%20%20%20%20onViewChange%20(val%2C%20count)%20%7B%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-built_in%22%3Econsole%3C%2Fspan%3E.log(%3Cspan%20class%3D%22hljs-string%22%3E'on%20view%20change'%3C%2Fspan%3E%2C%20val%2C%20count)%0A%20%20%20%20%7D%0A%20%20%7D%2C%0A%20%20data%20()%20%7B%0A%20%20%20%20%3Cspan%20class%3D%22hljs-keyword%22%3Ereturn%3C%2Fspan%3E%20%7B%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3EendDate%3C%2Fspan%3E%3A%20dayjs().add(%3Cspan%20class%3D%22hljs-number%22%3E30%3C%2Fspan%3E%2C%20%3Cspan%20class%3D%22hljs-string%22%3E'd'%3C%2Fspan%3E).format(%3Cspan%20class%3D%22hljs-string%22%3E'YYYY-MM-DD'%3C%2Fspan%3E)%2C%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3Eshow%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-literal%22%3Etrue%3C%2Fspan%3E%2C%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3Evalue%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-string%22%3E''%3C%2Fspan%3E%2C%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3ElistValue%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-string%22%3E''%3C%2Fspan%3E%2C%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3Erange%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-literal%22%3Efalse%3C%2Fspan%3E%2C%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3EshowLastMonth%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-literal%22%3Etrue%3C%2Fspan%3E%2C%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3EshowNextMonth%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-literal%22%3Etrue%3C%2Fspan%3E%2C%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3EhighlightWeekend%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-literal%22%3Efalse%3C%2Fspan%3E%2C%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3Ereturn6Rows%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-literal%22%3Etrue%3C%2Fspan%3E%2C%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3EhideHeader%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-literal%22%3Efalse%3C%2Fspan%3E%2C%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3EhideWeekList%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-literal%22%3Efalse%3C%2Fspan%3E%2C%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3EreplaceTextList%3C%2Fspan%3E%3A%20%7B%7D%2C%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3Ereplace%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-literal%22%3Efalse%3C%2Fspan%3E%2C%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3EchangeWeeksList%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-literal%22%3Efalse%3C%2Fspan%3E%2C%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3EweeksList%3C%2Fspan%3E%3A%20%5B%5D%2C%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3EuseCustomFn%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-literal%22%3Efalse%3C%2Fspan%3E%2C%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3EbuildSlotFn%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-function%22%3E%3Cspan%20class%3D%22hljs-params%22%3E()%3C%2Fspan%3E%20%3D%26gt%3B%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-string%22%3E''%3C%2Fspan%3E%2C%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3EdisablePast%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-literal%22%3Efalse%3C%2Fspan%3E%2C%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3EdisableFuture%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-literal%22%3Efalse%3C%2Fspan%3E%2C%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3EdisableWeekend%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-literal%22%3Efalse%3C%2Fspan%3E%2C%0A%20%20%20%20%20%20disableDateFunction%20(date)%20%7B%0A%20%20%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-keyword%22%3Eif%3C%2Fspan%3E%20(date.formatedDate%20%3D%3D%3D%20%3Cspan%20class%3D%22hljs-string%22%3E'2017-10-16'%3C%2Fspan%3E)%20%7B%0A%20%20%20%20%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-keyword%22%3Ereturn%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-literal%22%3Etrue%3C%2Fspan%3E%0A%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%20%20%7D%0A%20%20%20%20%7D%0A%20%20%7D%2C%0A%20%20%3Cspan%20class%3D%22hljs-attr%22%3Ewatch%3C%2Fspan%3E%3A%20%7B%0A%20%20%20%20replace%20(val)%20%7B%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-keyword%22%3Ethis%3C%2Fspan%3E.replaceTextList%20%3D%20val%20%3F%20%7B%0A%20%20%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-string%22%3E'TODAY'%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-string%22%3E'%E4%BB%8A'%3C%2Fspan%3E%0A%20%20%20%20%20%20%7D%20%3A%20%7B%7D%0A%20%20%20%20%7D%2C%0A%20%20%20%20useCustomFn%20(val)%20%7B%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-keyword%22%3Ethis%3C%2Fspan%3E.buildSlotFn%20%3D%20val%20%3F%20%3Cspan%20class%3D%22hljs-function%22%3E(%3Cspan%20class%3D%22hljs-params%22%3Eline%2C%20index%2C%20data%3C%2Fspan%3E)%20%3D%26gt%3B%3C%2Fspan%3E%20%7B%0A%20%20%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-keyword%22%3Ereturn%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-regexp%22%3E%2F8%2F%3C%2Fspan%3E.test(data.date)%20%3F%20%3Cspan%20class%3D%22hljs-string%22%3E'%26lt%3Bdiv%20style%3D%22font-size%3A12px%3Btext-align%3Acenter%3B%22%26gt%3B%26lt%3Bspan%20style%3D%22display%3Ainline-block%3Bwidth%3A5px%3Bheight%3A5px%3Bbackground-color%3Ared%3Bborder-radius%3A50%25%3B%22%26gt%3B%26lt%3B%2Fspan%26gt%3B%26lt%3B%2Fdiv%26gt%3B'%3C%2Fspan%3E%20%3A%20%3Cspan%20class%3D%22hljs-string%22%3E'%26lt%3Bdiv%20style%3D%22height%3A19px%3B%22%26gt%3B%26lt%3B%2Fdiv%26gt%3B'%3C%2Fspan%3E%0A%20%20%20%20%20%20%7D%20%3A%20%3Cspan%20class%3D%22hljs-function%22%3E%3Cspan%20class%3D%22hljs-params%22%3E()%3C%2Fspan%3E%20%3D%26gt%3B%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-string%22%3E''%3C%2Fspan%3E%0A%20%20%20%20%7D%2C%0A%20%20%20%20changeWeeksList%20(val)%20%7B%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-keyword%22%3Ethis%3C%2Fspan%3E.weeksList%20%3D%20val%20%3F%20%5B%3Cspan%20class%3D%22hljs-string%22%3E'%E6%97%A5'%3C%2Fspan%3E%2C%20%3Cspan%20class%3D%22hljs-string%22%3E'%E4%B8%80'%3C%2Fspan%3E%2C%20%3Cspan%20class%3D%22hljs-string%22%3E'%E4%BA%8C'%3C%2Fspan%3E%2C%20%3Cspan%20class%3D%22hljs-string%22%3E'%E4%B8%89'%3C%2Fspan%3E%2C%20%3Cspan%20class%3D%22hljs-string%22%3E'%E5%9B%9B'%3C%2Fspan%3E%2C%20%3Cspan%20class%3D%22hljs-string%22%3E'%E4%BA%94'%3C%2Fspan%3E%2C%20%3Cspan%20class%3D%22hljs-string%22%3E'%E5%85%AD%20'%3C%2Fspan%3E%5D%20%3A%20%5B%3Cspan%20class%3D%22hljs-string%22%3E'Su'%3C%2Fspan%3E%2C%20%3Cspan%20class%3D%22hljs-string%22%3E'Mo'%3C%2Fspan%3E%2C%20%3Cspan%20class%3D%22hljs-string%22%3E'Tu'%3C%2Fspan%3E%2C%20%3Cspan%20class%3D%22hljs-string%22%3E'We'%3C%2Fspan%3E%2C%20%3Cspan%20class%3D%22hljs-string%22%3E'Th'%3C%2Fspan%3E%2C%20%3Cspan%20class%3D%22hljs-string%22%3E'Fr'%3C%2Fspan%3E%2C%20%3Cspan%20class%3D%22hljs-string%22%3E'Sa'%3C%2Fspan%3E%5D%0A%20%20%20%20%7D%0A%20%20%7D%2C%0A%20%20%3Cspan%20class%3D%22hljs-attr%22%3Ecomponents%3C%2Fspan%3E%3A%20%7B%0A%20%20%20%20InlineCalendar%2C%0A%20%20%20%20Group%2C%0A%20%20%20%20XSwitch%2C%0A%20%20%20%20Radio%2C%0A%20%20%20%20XButton%2C%0A%20%20%20%20Cell%2C%0A%20%20%20%20Divider%0A%20%20%7D%0A%7D%0A%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Escript%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%0A%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Estyle%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Elang%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22less%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Escoped%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22css%22%3E%0A%3Cspan%20class%3D%22hljs-selector-class%22%3E.inline-calendar-demo%3C%2Fspan%3E%20%7B%0A%20%20%3Cspan%20class%3D%22hljs-attribute%22%3Ebackground%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-built_in%22%3Ergba%3C%2Fspan%3E(255%2C255%2C255%2C0.9)%3B%0A%7D%0A%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Estyle%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%3C%2Fcode%3E%3C%2Fpre%3E");

var domainMap = {
  'development': 'http://localhost:8080/',
  'production': 'https://vux-demos.bobjoy.eu.org/'
};

/* harmony default export */ __webpack_exports__["default"] = ({
  head: {
    title: 'InlineCalendar 组件使用教程 | VUX - 基于 WeUI 和 Vue 的移动端组件库',
    meta: [{
      name: 'description',
      content: 'Vue component inline-calendar for the VUX framework.'
    }, {
      name: 'keywords',
      content: 'inline-calendar, vue-inline-calendar, vux-inline-calendar, vue mobile components'
    }, {
      property: 'og:title',
      content: 'InlineCalendar 组件使用教程 | VUX - 基于 WeUI 和 Vue 的移动端组件库'
    }, {
      property: 'og:description',
      content: 'Vue component inline-calendar for the VUX framework.'
    }],

    link: [{ "rel": "alternate", "hreflang": "en", "href": "/en/components/inline-calendar.html" }],
    script: [{
      innerHTML: '{"@context":"http://schema.org/","@type":"SoftwareApplication","name":"Vue Component inline-calendar","screenshot":"","description":"Vue.js component for VUX","url":"/zh-CN/components/inline-calendar.html","applicationCategory":"组件","author":{"@type":"Organization","name":"VUX","url":"https://vux.li"},"downloadUrl":"https://vux.li","softwareVersion":"2.11.1","aggregateRating":{"@type":"AggregateRating","ratingValue":5,"reviewCount":1},"operatingSystem":"iOS >= 7, Android >= 4.1","offers":{"@type":"Offer","price":0,"priceCurrency":"CNY","availability":"http://schema.org/InStock"}}',
      type: 'application/ld+json'
    }],
    __dangerouslyDisableSanitizers: ['script']
  },
  filters: {
    parseCode: function parseCode(str) {
      return str.replace(/`(.*?)`/g, '<code>$1</code>');
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var rs;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('https://api.github.com/search/issues?q=repo:airyland/vux%20label:component/' + _this.componentName);

            case 2:
              rs = _context.sent;

              _this.issues = rs.data.items;
              _this.hasReady = true;

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    sourceCodeDialogVisibility: function sourceCodeDialogVisibility(val) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var mask;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!val) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 3;
                return _this2.$nextTick();

              case 3:
                mask = document.querySelector('.v-modal');

                mask && mask.addEventListener('click', function () {
                  _this2.sourceCodeDialogVisibility = false;
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  methods: {
    onCopyError: function onCopyError() {
      this.$message({
        type: 'error',
        message: '复制失败'
      });
    },
    onCopy: function onCopy() {
      this.$message({
        type: 'success',
        message: '复制成功'
      });
    },
    showSourceCode: function showSourceCode() {
      this.sourceCodeDialogVisibility = true;
    },
    getTypeHTML: function getTypeHTML(type) {
      type = type || 'String';
      if (/,/.test(type)) {
        var list = type.split(',').map(function (one) {
          return one.replace(/^s+|s+$/g, '');
        }).map(function (one) {
          var type = one ? one.toLowerCase() : 'string';
          return '<span class="type">' + type + '</span>';
        });
        return list.join('<br>');
      } else {
        type = type ? type.toLowerCase() : 'string';
        return '<span class="type">' + type + '</span>';
      }
    }
  },
  computed: {
    lang: function lang() {
      if (this.$route.path.indexOf('/en/') !== -1) {
        return 'en';
      }
      if (this.$route.path.indexOf('/zh-CN/') !== -1) {
        return 'zh-CN';
      }
      return 'en';
    }
  },
  data: function data() {
    return {
      demos: demos,
      isBeta: false,
      hasReady: false,
      issues: [],
      componentName: 'inline-calendar',
      demoCode: demoCode,
      sourceCodeDialogVisibility: false,
      showQr: false,
      metas: metas,
      gitMetas: gitMetas,
      componentList: componentList,
      localImportCode: "import { InlineCalendar } from 'vux'\n\nexport default {\n  components: {\n    InlineCalendar\n  }\n}",
      globalImportCode: "// \u5728\u5165\u53E3\u6587\u4EF6\u5168\u5C40\u5F15\u5165\n\nimport Vue from 'vue'\nimport { InlineCalendar } from 'vux'\n\nVue.component('inline-calendar', InlineCalendar)\n",
      needImport: true,
      toc: [],
      domain: domainMap["production"]
    };
  }
});

/***/ }),

/***/ 1411:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(306)(false);
// imports


// module
exports.push([module.i, ".component-box{position:relative}.component-demo{position:absolute;right:5px;top:15px}.prop-color{display:inline-block;width:10px;height:10px;border:1px solid #aaa}.changelog-version{width:110px;display:inline-block}.component-extra-links{position:relative;font-size:12px}.component-extra-links a{padding-right:10px;color:#999}", ""]);

// exports


/***/ }),

/***/ 1577:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1411);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(307)("f4f9d99c", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"autoprefixer\":false,\"sourceMap\":false,\"minimize\":true}!../../node_modules/ream/node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-41619f18\",\"scoped\":false,\"hasInlineConfig\":true}!../../node_modules/ream/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./inline-calendar.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"autoprefixer\":false,\"sourceMap\":false,\"minimize\":true}!../../node_modules/ream/node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-41619f18\",\"scoped\":false,\"hasInlineConfig\":true}!../../node_modules/ream/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./inline-calendar.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2183:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-box",
    class: _vm.demos.length ? 'components-with-toc' : ''
  }, [_c('div', {
    class: _vm.demos.length ? 'component-header-v2' : 'component-header-v1'
  }, [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "intro"
    }
  }, [_vm._v("InlineCalendar")]), _c('div', {
    staticClass: "title-box"
  }, [(_vm.isBeta) ? _c('el-badge', {
    attrs: {
      "value": "Beta"
    }
  }, [_c('h1', {
    staticClass: "vux-component-name"
  }, [_vm._v("InlineCalendar")])]) : _c('h1', {
    staticClass: "vux-component-name"
  }, [_vm._v("InlineCalendar")]), _c('p', {
    staticClass: "component-extra-links"
  }, [_c('a', {
    attrs: {
      "href": "https://vux-demos.bobjoy.eu.org/#/component/inline-calendar",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")]), (!_vm.demos.length) ? _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/InlineCalendar.vue",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showSourceCode($event)
      }
    }
  }, [_vm._v("demo 源码")]) : _vm._e(), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/inline-calendar/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("编辑文档")]), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/inline-calendar/",
      "target": "_blank"
    }
  }, [_vm._v("组件源码")]), (_vm.hasReady) ? _c('el-popover', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "qr",
    attrs: {
      "width": "100",
      "src": "https://qr.vux.li/api.php?text=https%3A%2F%2Fvux-demos.bobjoy.eu.org%2F%23%2Fcomponent%2Finline-calendar"
    }
  })]), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    slot: "reference"
  }, [_vm._v("\n              二维码\n              ")])]) : _vm._e()], 1), _c('div', {
    staticClass: "component-description"
  }, [(false) ? void 0 : _vm._e()], 2)], 1), (!_vm.demos.length) ? _c('div', {
    staticClass: "component-demo",
    staticStyle: {
      "width": "377px",
      "height": "600px",
      "display": "inline-block",
      "border": "1px solid #ececec",
      "border-radius": "5px",
      "overflow": "hidden",
      "z-index": "2500"
    }
  }, [_c('iframe', {
    attrs: {
      "src": "https://vux-demos.bobjoy.eu.org?locale=zh-CN&transition=none/#/component/inline-calendar",
      "width": "375",
      "height": "600",
      "border": "0",
      "frameborder": "0"
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "toc"
  }, _vm._l((_vm.toc), function(t) {
    return _c('ul', [_c('li', [_c('a', {
      attrs: {
        "href": '#' + (t.anchor || t.title)
      }
    }, [_vm._v(_vm._s(t.title))]), _vm._l((t.list), function(_t) {
      return (t.list) ? _c('ul', [_c('li', [_c('a', {
        attrs: {
          "href": '#' + _t.anchor
        }
      }, [_vm._v(_vm._s(_t.title.slice(0, 12)))])])]) : _vm._e()
    })], 2)])
  })), (_vm.needImport) ? [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "install"
    }
  }, [_vm._v("Install")]), _c('h2', [_vm._v("安装")]), _c('el-tabs', [_c('el-tab-pane', {
    attrs: {
      "label": "局部注册"
    }
  }, [_c('div', {
    staticClass: "import-code-box"
  }, [_c('el-tooltip', {
    attrs: {
      "content": "点击复制",
      "placement": "top"
    }
  }, [_c('span', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.localImportCode),
      expression: "localImportCode",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.onCopyError),
      expression: "onCopyError",
      arg: "error"
    }]
  }, [_c('el-icon', {
    staticClass: "el-icon-document"
  })], 1)]), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { InlineCalendar } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("default")]), _vm._v(" {\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("components")]), _vm._v(": {\n    InlineCalendar\n  }\n}")])])], 1)]), _c('el-tab-pane', {
    attrs: {
      "label": "全局注册"
    }
  }, [_c('div', {
    staticClass: "import-code-box"
  }, [_c('el-tooltip', {
    attrs: {
      "content": "点击复制",
      "placement": "top"
    }
  }, [_c('span', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.globalImportCode),
      expression: "globalImportCode",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.onCopyError),
      expression: "onCopyError",
      arg: "error"
    }]
  }, [_c('el-icon', {
    staticClass: "el-icon-document"
  })], 1)]), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 在入口文件全局引入")]), _vm._v("\n\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" Vue "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vue'")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { InlineCalendar } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n\nVue.component("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'inline-calendar'")]), _vm._v(", InlineCalendar)\n")])])], 1)])], 1)] : [_c('div', {
    staticClass: "tip"
  }, [_c('p', [_vm._v("该组件可以直接使用，不需要引入。")])])], (_vm.metas.tip) ? _c('div', {
    staticClass: "tip",
    staticStyle: {
      "width": "600px"
    }
  }) : _vm._e(), (_vm.metas.example) ? _c('h2', [_vm._v("使用例子")]) : _vm._e(), (_vm.metas.example) ? _c('div', {
    staticStyle: {
      "width": "600px"
    }
  }) : _vm._e()], 2), (_vm.metas.extra && _vm.metas.extra['zh-CN']) ? _c('div') : _vm._e(), (_vm.metas.extra && !_vm.metas.extra['zh-CN']) ? _c('div') : _vm._e(), (_vm.demos.length) ? _c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "examples"
    }
  }, [_vm._v("Examples")]) : _vm._e(), _c('br'), _vm._l((_vm.demos), function(demo) {
    return (_vm.demos.length) ? [_c('a', {
      staticClass: "anchor",
      attrs: {
        "id": 'examples:' + demo.title
      }
    }, [_vm._v(_vm._s(demo.title))]), _c('br'), _c('div', {
      staticClass: "demo-header"
    }, [_c('span', {
      staticClass: "demo-title"
    }, [_vm._v(_vm._s(demo.title))])]), _c('div', {
      staticClass: "demos",
      style: ({
        height: demo.height
      })
    }, [_c('div', {
      staticClass: "demo-iframe-box"
    }, [_c('lazy-component', [_c('iframe', {
      staticStyle: {
        "margin": "0 auto"
      },
      attrs: {
        "src": _vm.domain + '?no-background-color=' + demo.noBackgroundColor + '&locale=zh-CN&transition=none&hide-nav=true&hide-tab-bar=true#/components/' + demo.file,
        "width": "375",
        "height": "600",
        "border": "0",
        "frameborder": "0"
      }
    })], 1)], 1), _c('div', {
      staticClass: "demo-code-box",
      style: ({
        overflow: demo.height === demo.oriHeight ? 'hidden' : 'scroll'
      })
    }, [_c('div', {
      attrs: {
        "contenteditable": ""
      },
      domProps: {
        "innerHTML": _vm._s(demo.code)
      }
    }), (demo.height === demo.oriHeight) ? _c('div', {
      staticClass: "demo-code-masker",
      on: {
        "click": function($event) {
          demo.height = 'auto'
        }
      }
    }, [_c('div', [_c('img', {
      staticClass: "demo-qr",
      attrs: {
        "width": "100",
        "src": 'https://qr.vux.li/api.php?text=' + encodeURIComponent(_vm.domain + '?locale=zh-CN#/components/' + demo.file)
      }
    }), _c('br'), _c('span', [_c('el-icon', {
      staticClass: "el-icon-arrow-left"
    }), _c('el-icon', {
      staticClass: "el-icon-arrow-right"
    }), _vm._v("\n                    Show code\n                  "), _c('br')], 1)])]) : _vm._e(), (demo.height === 'auto') ? _c('span', {
      staticClass: "hide-code",
      on: {
        "click": function($event) {
          demo.height = demo.oriHeight
        }
      }
    }, [_c('el-icon', {
      staticClass: "el-icon-close"
    })], 1) : _vm._e()])])] : _vm._e()
  }), _vm._l((_vm.componentList), function(component) {
    return [_c('div', [(_vm.componentList.length > 1) ? _c('a', {
      staticClass: "anchor",
      attrs: {
        "id": 'components:' + component.name
      }
    }, [_vm._v(_vm._s(component.name))]) : _c('a', {
      staticClass: "anchor",
      attrs: {
        "id": "api"
      }
    }, [_vm._v("API")]), _c('br'), _c('h2', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.componentList.length > 1),
        expression: "componentList.length > 1"
      }],
      staticClass: "vux-component-name-sub-item"
    }, [_vm._v(_vm._s(component.name))]), (component.meta.items && component.meta.description) ? [_c('div', {
      domProps: {
        "innerHTML": _vm._s(component.meta.description)
      }
    })] : _vm._e(), (component.meta.props) ? [_c('h2', [_vm._v("属性")]), _c('table', [_vm._m(0, true), _c('tbody', _vm._l((component.meta.props), function(prop, i) {
      return _c('tr', [_c('td', {
        staticClass: "prop-name"
      }, [_c('el-tooltip', {
        attrs: {
          "content": "点击复制",
          "placement": "left",
          "hide-after": 0,
          "open-delay": 50
        }
      }, [_c('span', {
        directives: [{
          name: "clipboard",
          rawName: "v-clipboard:copy",
          value: (i),
          expression: "i",
          arg: "copy"
        }, {
          name: "clipboard",
          rawName: "v-clipboard:success",
          value: (_vm.onCopy),
          expression: "onCopy",
          arg: "success"
        }]
      }, [_vm._v(_vm._s(i))])])], 1), _c('td', {
        domProps: {
          "innerHTML": _vm._s(_vm.getTypeHTML(prop.type))
        }
      }), _c('td', [_vm._v(_vm._s(prop.default))]), _c('td', {
        domProps: {
          "innerHTML": _vm._s(prop['zh-CN'] ? prop['zh-CN'].replace(/`(.*?)`/g, '<code>$1</code>') : '')
        }
      }), _c('td', [_vm._v(_vm._s(prop.version || '--'))])])
    }))])] : _vm._e(), (component.meta.events) ? [_c('h2', [_vm._v("事件")]), _c('table', [_vm._m(1, true), _c('tbody', _vm._l((component.meta.events), function(event, i) {
      return _c('tr', [_c('td', {
        staticClass: "prop-name"
      }, [_c('el-tooltip', {
        attrs: {
          "content": "点击复制",
          "placement": "left",
          "hide-after": 0,
          "open-delay": 50
        }
      }, [_c('span', {
        directives: [{
          name: "clipboard",
          rawName: "v-clipboard:copy",
          value: ('@' + i),
          expression: "'@' + i",
          arg: "copy"
        }, {
          name: "clipboard",
          rawName: "v-clipboard:success",
          value: (_vm.onCopy),
          expression: "onCopy",
          arg: "success"
        }]
      }, [_vm._v("@" + _vm._s(i))])])], 1), _c('td', {
        domProps: {
          "innerHTML": _vm._s(event.params ? event.params.replace(/`(.*?)`/g, '<code>$1</code>') : '--')
        }
      }), _c('td', {
        domProps: {
          "innerHTML": _vm._s(event['zh-CN'] ? event['zh-CN'].replace(/`(.*?)`/g, '<code>$1</code>') : '--')
        }
      }), _c('td', [_vm._v(_vm._s(event['version'] || '--'))])])
    }))])] : _vm._e(), (component.meta.slots) ? [_c('h2', [_vm._v("插槽")]), _c('table', [_vm._m(2, true), _c('tbody', _vm._l((component.meta.slots), function(slot, i) {
      return _c('tr', {
        class: {
          'slot-disabled': slot['status'] === 'deprecated'
        }
      }, [_c('td', {
        staticClass: "prop-name"
      }, [_c('el-tooltip', {
        attrs: {
          "content": "点击复制",
          "placement": "left",
          "hide-after": 0,
          "open-delay": 50
        }
      }, [_c('span', {
        directives: [{
          name: "clipboard",
          rawName: "v-clipboard:copy",
          value: (i),
          expression: "i",
          arg: "copy"
        }, {
          name: "clipboard",
          rawName: "v-clipboard:success",
          value: (_vm.onCopy),
          expression: "onCopy",
          arg: "success"
        }]
      }, [_vm._v(_vm._s(i === 'default' ? '默认插槽' : i))])])], 1), _c('td', {
        domProps: {
          "innerHTML": _vm._s(slot['zh-CN'] ? slot['zh-CN'].replace(/`(.*?)`/g, '<code>$1</code>') : '')
        }
      }), _c('td', [_vm._v(_vm._s(slot['version'] || '--'))])])
    }))])] : _vm._e(), (component.meta.methods) ? [_c('h2', [_vm._v("方法")]), _c('table', [_vm._m(3, true), _c('tbody', _vm._l((component.meta.methods), function(method, i) {
      return _c('tr', [_c('td', {
        staticClass: "prop-name"
      }, [_c('el-tooltip', {
        attrs: {
          "content": "点击复制",
          "placement": "left",
          "hide-after": 0,
          "open-delay": 50
        }
      }, [_c('span', {
        directives: [{
          name: "clipboard",
          rawName: "v-clipboard:copy",
          value: (i),
          expression: "i",
          arg: "copy"
        }, {
          name: "clipboard",
          rawName: "v-clipboard:success",
          value: (_vm.onCopy),
          expression: "onCopy",
          arg: "success"
        }]
      }, [_vm._v(_vm._s(i))])])], 1), _c('td', {
        domProps: {
          "innerHTML": _vm._s(method['params'] ? method['params'].replace(/`(.*?)`/g, '<code>$1</code>') : '')
        }
      }), _c('td', {
        domProps: {
          "innerHTML": _vm._s(method['zh-CN'] ? method['zh-CN'].replace(/`(.*?)`/g, '<code>$1</code>') : '')
        }
      }), _c('td', [_vm._v(_vm._s(method['version']))])])
    }))])] : _vm._e(), (component.meta.variables) ? [_c('a', {
      staticClass: "anchor",
      attrs: {
        "id": "variables"
      }
    }, [_vm._v("Variables")]), _c('br'), _c('h2', [_vm._v("样式变量")]), _c('table', [_vm._m(4, true), _c('tbody', _vm._l((component.meta.variables), function(variable, i) {
      return _c('tr', [_c('td', {
        staticClass: "prop-name"
      }, [_c('el-tooltip', {
        attrs: {
          "content": "点击复制",
          "placement": "left",
          "hide-after": 0,
          "open-delay": 50
        }
      }, [_c('span', {
        directives: [{
          name: "clipboard",
          rawName: "v-clipboard:copy",
          value: ('@' + variable.name),
          expression: "'@' + variable.name",
          arg: "copy"
        }, {
          name: "clipboard",
          rawName: "v-clipboard:success",
          value: (_vm.onCopy),
          expression: "onCopy",
          arg: "success"
        }]
      }, [_vm._v("@" + _vm._s(variable.name))])])], 1), _c('td', [(!_vm.$refs['propColor' + i] || (_vm.$refs['propColor' + i][0] && _vm.$refs['propColor' + i][0].style.backgroundColor)) ? _c('em', {
        ref: 'propColor' + i,
        refInFor: true,
        staticClass: "prop-color",
        style: ({
          backgroundColor: variable.value
        })
      }) : _vm._e(), _vm._v("\n                    " + _vm._s(variable.value) + "\n                  ")]), _c('td', [_vm._v(_vm._s(variable['desc']['zh-CN'] || '--'))]), _c('td', [_vm._v(_vm._s(variable.inherited_name))])])
    }))])] : _vm._e(), (component.meta.tips && component.meta.tips['zh-CN']) ? [_c('a', {
      staticClass: "anchor",
      attrs: {
        "id": "tips"
      }
    }, [_vm._v("重要提示及已知问题")]), _c('br'), _c('h2', [_vm._v("重要提示及已知问题")]), _c('div', [_c('ul', _vm._l((component.meta.tips['zh-CN']), function(tip) {
      return _c('li', [_c('el-tag', {
        staticClass: "component-tip-tag",
        attrs: {
          "size": "mini",
          "type": "success"
        }
      }, [_vm._v("Q")]), _c('span', {
        staticClass: "component-tip-question"
      }, [_vm._v(_vm._s(tip.q))]), _c('div', {
        staticClass: "tip-answer-box",
        domProps: {
          "innerHTML": _vm._s(tip.a)
        }
      })], 1)
    }))])] : _vm._e()], 2)]
  }), _c('br'), (_vm.issues.length) ? _c('div', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "Issues"
    }
  }, [_vm._v("Issues")]), _c('br'), _c('h2', [_vm._v("相关 issue")]), _c('ul', _vm._l((_vm.issues), function(issue) {
    return _c('li', [_c('a', {
      attrs: {
        "target": "_blank",
        "href": issue.html_url
      }
    }, [_vm._v("#" + _vm._s(issue.number) + " "), _c('span', {
      staticStyle: {
        "color": "#666"
      }
    }, [_vm._v(_vm._s(issue.title))])])])
  }))]) : _vm._e(), _c('br'), (_vm.gitMetas) ? _c('div', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "contributors"
    }
  }, [_vm._v("贡献者")]), _c('h2', [_vm._v("贡献者")]), _c('p', [_vm._v("该组件(包含文档)迭代次数 " + _vm._s(_vm.gitMetas.commitCount) + "，贡献人数 " + _vm._s(_vm.gitMetas.commitUniqueCount) + "\n        ")]), _vm._l((_vm.gitMetas.commitMembers), function(person) {
    return _c('a', {
      staticClass: "contributor-item",
      attrs: {
        "href": 'https://github.com/' + person.authorName,
        "target": "_blank",
        "title": 'contribute' + person.count
      }
    }, [_vm._v(_vm._s(person.authorName))])
  })], 2) : _vm._e(), _c('br'), (_vm.metas.changes) ? _c('div', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "changelog"
    }
  }, [_vm._v("Changelog")]), _c('br'), _c('h2', [_vm._v("发布日志")]), (_vm.metas.changes) ? _c('ul', [_vm._l((_vm.metas.changes), function(changelog, version) {
    return _vm._l((changelog['zh-CN']), function(log) {
      return _c('li', [_c('router-link', {
        staticClass: "changelog-version",
        attrs: {
          "to": '/zh-CN/changelog/' + version + '.html'
        }
      }, [_vm._v(_vm._s(version))]), _vm._v(" " + _vm._s(log) + "\n            ")], 1)
    })
  })], 2) : _vm._e()]) : _vm._e(), (_vm.metas.references) ? _c('h2', [_vm._v("参考资料")]) : _vm._e(), (_vm.metas.references) ? _c('ul', _vm._l((_vm.metas.references['zh-CN']), function(link) {
    return _c('li', [_c('a', {
      attrs: {
        "href": link.link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(link.title))])])
  })) : _vm._e(), _c('el-dialog', {
    staticClass: "sourcec-code-dialog",
    attrs: {
      "top": "0",
      "width": "80%",
      "visible": _vm.sourceCodeDialogVisibility
    },
    on: {
      "update:visible": function($event) {
        _vm.sourceCodeDialogVisibility = $event
      }
    }
  }, [_c('div', {
    staticClass: "code-box",
    attrs: {
      "contenteditable": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.demoCode)
    }
  })])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("名字")]), _c('td', {
    staticStyle: {
      "width": "48px"
    }
  }, [_vm._v("类型")]), _c('td', [_vm._v("默认值")]), _c('td', [_vm._v("说明")]), _c('td', [_vm._v("版本要求")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("名字")]), _c('td', [_vm._v("参数")]), _c('td', [_vm._v("说明")]), _c('td', [_vm._v("版本要求")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("名字")]), _c('td', [_vm._v("说明")]), _c('td', [_vm._v("版本要求")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("名字")]), _c('td', [_vm._v("参数")]), _c('td', [_vm._v("说明")]), _c('td', [_vm._v("版本要求")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("名字")]), _c('td', [_vm._v("默认值")]), _c('td', [_vm._v("说明")]), _c('td', [_vm._v("继承自变量")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-41619f18", module.exports)
  }
}

/***/ }),

/***/ 2512:
/***/ (function(module, exports) {

module.exports = {
	"commitCount": 1,
	"commitMembers": [
		{
			"count": 1,
			"authorName": "Bobjoy"
		}
	],
	"commitUniqueCount": 1
};

/***/ }),

/***/ 422:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1577)
}
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1298),
  /* template */
  __webpack_require__(2183),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/zh-CN/components/inline-calendar.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] inline-calendar.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-41619f18", Component.options)
  } else {
    hotAPI.reload("data-v-41619f18", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// 57.27cc2b9c.js